import {useDispatch, useSelector} from "react-redux";
import {formatPrice, getStrLang} from "../Helpers/functions";
import {actionsState as projectState} from "../Redux/project";
const OrderMenu = ()=>{
    const dispatch = useDispatch();
    const price = useSelector(store=>store.modules.price);
    if (window.conf_nofunc) {
        return <div className="order-block nofunc">
            <div className={"order-block__bottom"}>
                <a href="https://olissys.com/" className={"order-block__order-btn"}>{ getStrLang('c3d_ffJ6A') }</a>
            </div>
        </div>
    } else {
        return <div className="order-block">
            <div className={"order-block__top"}>
                <button className={"order-block__all-btn"} onClick={()=>{dispatch(projectState.setModal('modulesList'));}}>
                    { getStrLang('c3d_jp0tg') }
                </button>
                <button className={"order-block__save-btn"} onClick={()=>dispatch({type:'SAVE_PROJECT'})}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
                        <path fill="currentColor" d="M4.86,9.73h5.28a.44.44,0,0,0,.44-.44.44.44,0,0,0-.44-.44H4.86a.44.44,0,0,0-.44.44A.44.44,0,0,0,4.86,9.73Z"></path>
                        <path fill="currentColor" d="M4.86,11.48h5.28a.44.44,0,1,0,0-.87H4.86a.44.44,0,1,0,0,.87Z"></path>
                        <path fill="currentColor" d="M14.87,2.47,12.53.13A.46.46,0,0,0,12.22,0H.44A.44.44,0,0,0,0,.44V14.56A.44.44,0,0,0,.44,15H14.56a.44.44,0,0,0,.44-.44V2.78A.46.46,0,0,0,14.87,2.47ZM3.54.88H9.7V3.81H3.54Zm7.92,13.24H3.54V8h7.92Zm2.66,0H12.33V7.53a.44.44,0,0,0-.44-.44H3.11a.44.44,0,0,0-.44.44v6.59H.88V.88H2.67V4.25a.44.44,0,0,0,.44.44h7a.44.44,0,0,0,.44-.44V.88H12L14.12,3Z"></path>
                        <path fill="currentColor" d="M4.86,13.24h5.28a.44.44,0,0,0,.44-.44.44.44,0,0,0-.44-.44H4.86a.44.44,0,0,0-.44.44A.44.44,0,0,0,4.86,13.24Z"></path>
                    </svg>
                </button>
            </div>
            <div className={"order-block__bottom"}>
                <div className={"order-block__price-block"}>
                    <div className={"order-block__price-txt"}>{ getStrLang('c3d_JHNET') }</div>
                    <div className={"order-block__price"}>{formatPrice(price)}</div>
                </div>
                {!window.showroom && <button className={"order-block__order-btn"} onClick={()=>dispatch({type:'BUY_PROJECT'})}>{ getStrLang('c3d_4dqWq') }</button>}
                {window.showroom && <a href="/contacts/" className={"order-block__order-btn"}>{ getStrLang('c3d_7t1Lo') }</a>}
            </div>
        </div>
    }
}
export default OrderMenu
